import { usd } from "@/lib/api";

export const SplitPay = ({ total, dark = false, testId = "split-pay-note" }) => (
  <p data-testid={testId} className={`text-xs leading-relaxed ${dark ? "text-[#C9BFB5]" : "text-[#4A4543]"}`}>
    Or <strong className={dark ? "text-[#F2EAE1]" : "text-[#181615]"}>4 interest-free payments of {usd(total / 4)}</strong> with Klarna or Afterpay, or monthly with Affirm — choose at checkout.
  </p>
);
